import { IkeDraw } from '../draw';

export interface DeleteEvent {
	drawableId: string;
	$event: Event;
}

export function drawableDeleteBinding(dc: IkeDraw, evt: DeleteEvent) {
	const drawable = dc.drawState.getDrawable(evt.drawableId);
	if (drawable == null) {
		return;
	}
	if (evt.$event != null) {
		evt.$event.preventDefault();
	}

	if (!drawable.isDeletable) {
		return;
	}

	if (dc.state.selectedId === evt.drawableId) {
		dc.state.setSelected(null, null);
	}

	if (dc.state.hoverId === evt.drawableId) {
		dc.state.setHovered(null);
	}

	drawable.remove();
}
